module.exports = __webpack_public_path__ + "static/media/blogthumb2.d47589f4.jpg";